import styled from 'styled-components6';
import { useJobStory } from './hooks/useJobStory';
import { PhotoCollage } from './PhotoCollage';
import { Body1, H3, mqDown, mqUp } from '../../theme';
import { JobReview } from './JobReview';
import { findReview } from '../../utils/findReview';
import { SimilarJobs } from './SimilarJobs';
import { JobMap } from './JobMap';
import { When } from 'react-if';
import { PluginWorkSite } from 'rwl-shared/dist/models/plugin/Plugin';
import { jobTitleGenerator } from 'rwl-shared/dist/utils/jobs/jobTitleGenerator';
import { LabelList } from '../JobList/JobCard/LabelsList';
import { pluginMediaFromJob } from '../../utils/pluginMediaFromJob';
import { removeDuplicateMedia } from '../../utils/removeDuplicateMedia';

const JobStoryContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: var(--rwl-spacing-md);
    width: 100%;
`;

const JobTitle = styled(H3)`
    margin: var(--rwl-spacing-md);
    margin-bottom: 0;
`;

const JobDescription = styled(Body1)``;

const JobMainContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: var(--rwl-spacing-md);
    flex: 3;
`;

const JobContent = styled.div`
    display: flex;
    ${mqDown('md')} {
        flex-direction: column;
    }
    ${mqUp('md')} {
        flex-direction: row;
        & > * {
            width: 50%;
        }
    }

    margin-left: var(--rwl-spacing-md);
    margin-right: var(--rwl-spacing-md);
    gap: var(--rwl-spacing-md);
`;

const JobContentNoSimilar = styled.div`
    display: flex;
    flex-direction: column;

    margin-left: var(--rwl-spacing-md);
    margin-right: var(--rwl-spacing-md);
    gap: var(--rwl-spacing-md);
`;

export const JobStory = ({ job }: { job: PluginWorkSite | undefined }) => {
    const { similarJobs, setSelectedMedia } = useJobStory();
    const review = findReview(job);

    if (!job) {
        return <JobStoryContainer></JobStoryContainer>;
    }

    const hasSimilar = similarJobs !== undefined && similarJobs.length;
    const Container = hasSimilar ? JobContent : JobContentNoSimilar;

    const allMedia = removeDuplicateMedia(pluginMediaFromJob(job));

    return (
        <JobStoryContainer id={'jobStory-' + job?.id}>
            <JobTitle id={'jobTitle'}>{jobTitleGenerator(job)}</JobTitle>
            <div>
                <PhotoCollage
                    onClickMedia={(media: any) => setSelectedMedia(media)}
                    media={allMedia}
                />
            </div>
            <Container>
                <JobMainContent>
                    <LabelList labels={job.labels} />
                    <JobDescription id={'jobDescription'}>
                        {job.description}
                    </JobDescription>
                    {review && <JobReview review={review} />}
                    <JobMap worksite={job} />
                </JobMainContent>
                <When condition={!!similarJobs?.length}>
                    <SimilarJobs />
                </When>
            </Container>
        </JobStoryContainer>
    );
};
